/** Inbox that receives inquiries from the contact form. */
export const CONTACT_EMAIL = 'contact@wolschlaeger.com';

export const CONTACT_PHONE = '+48 608 108 324';

/**
 * FormSubmit needs no API key — the endpoint is just the target address.
 * The first submission triggers a one-time activation email to CONTACT_EMAIL;
 * until that link is clicked, submissions are rejected rather than delivered.
 */
export const FORMSUBMIT_ENDPOINT = `https://formsubmit.co/ajax/${CONTACT_EMAIL}`;
